module.exports = __webpack_public_path__ + "img/expire.f7fec885.png";